import { Typography } from "../../../../../core/components/molecules/Typography"
import { AccordionCard } from "../../../../../core/components/templates/AccordionCard"
import { Modal } from "../../../../../core/components/templates/Modal"

interface ModalHowToProps {
  isOpen: boolean;
  onClose: () => void;
}

const ModalHowTo = ({ isOpen, onClose }: ModalHowToProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title='Como funciona?'
    >
      <AccordionCard key='update-schedule' title='Posso adicionar assuntos ao Plano Adaptativo?'>
        <Typography>
          Ao adicionar um assunto futuro, ele será automaticamente espelhado no dia escolhido. 
          Isso significa que qualquer avanço realizado em um dos dias será refletido no outro. 
          Da mesma forma, se quiser retomar um assunto de um dia anterior que não conseguiu estudar 
          ou que deseja revisar, basta adicioná-lo, e ele será incorporado ao novo dia. Essa flexibilidade 
          permite tanto avançar em tópicos futuros quanto recuperar conteúdos passados. Lembre-se de que só é 
          possível adicionar assuntos que foram priorizados no seu Cronograma Personalizado.
        </Typography>
      </AccordionCard>
    </Modal>
  )
}

export default ModalHowTo;